export default __webpack_public_path__ + "static/media/Book.be0c7707.jpg";